import type { ChatUiConfigResponse } from '@trimble-agentic-external-npm-local/agentic-platform-sdk-iframe-typescript';
import { createContext, useContext, type ReactNode } from 'react';

export type ExtendedChatUiConfiguration =
  ChatUiConfigResponse['configuration'] & {
    uiConfig: ChatUiConfigResponse['configuration']['uiConfig'] & {
      productAgents?: string[];
    };
  };

type EmbeddedConfigContextType = {
  chatConfig: ExtendedChatUiConfiguration;
};

export const EmbeddedConfigContext =
  createContext<EmbeddedConfigContextType | null>(null);

type EmbeddedConfigProviderProps = {
  children: ReactNode;
  chatConfig: ExtendedChatUiConfiguration;
};

export const EmbeddedConfigProvider = ({
  children,
  chatConfig,
}: EmbeddedConfigProviderProps) => {
  return (
    <EmbeddedConfigContext.Provider value={{ chatConfig }}>
      {children}
    </EmbeddedConfigContext.Provider>
  );
};

export const useEmbeddedConfig = () => {
  const context = useContext(EmbeddedConfigContext);
  if (!context) {
    throw new Error(
      'useEmbeddedConfig must be used within an EmbeddedConfigProvider'
    );
  }
  return context;
};
